<template>
  <v-card align="center" justify="center" min-width="27vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_MemberOptions', { name: member.user.firstName }) }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-5">
      <v-container fluid>
        <v-row align="center" justify="center">
          <div>
            <v-avatar size="70">
              <v-img :src="member.user.imageUrl !== null? member.user.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain></v-img>
            </v-avatar>
            <h3 class="text-center mt-3">{{ member.user.firstName }} {{ member.user.lastName }}</h3>
            <p class="text-center mt-3" v-if="!confirmDeleteView">
              {{ $t('memberSince') }} {{ monthNames[new Date(member.memberSince).getMonth()] }}
              {{ new Date(member.memberSince).getDate() }} /{{ new Date(member.memberSince).getFullYear().toString() }}
            </p>
            <p class="text-center mt-3" v-else v-html="$t('removeMessage', { name: member.user.firstName })"/>
          </div>
        </v-row>
        <v-row justify="center" v-if="!confirmDeleteView">
          <div>
            <v-btn style="width: 100%" v-if="member.rol !== 'FOUNDER'" @click="changeRol">
              {{ member.rol === 'MEMBER' ? $t('btnUpgrade') : $t('btnDowngrade') }}
            </v-btn>
            <v-btn style="width: 100%;" class="mt-2 remove-button" v-if="member.rol === 'MEMBER'" @click="confirmDeleteView = true">
              {{ $t('btnRemove') }}
            </v-btn>
          </div>
        </v-row>
        <v-row justify="center" v-else>
          <v-btn @click="confirmDeleteView = false">« {{ $t('btnCancel_MemberOptions') }}</v-btn>
          <v-btn class="ml-2 remove-button" style="width: 50%;" @click="removeMember">{{ $t('btnRemoveConfirm') }}</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "MemberOptions",
  props: {
    member: Object,
  },
  data() {
    return {
      monthNames: [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec')
      ],
      confirmDeleteView: false,
    };
  },
  methods: {
    changeRol() {
      if(this.member.rol === 'MEMBER')
        this.upgradeToAdmin();
      else
        this.downgradeToMember();
    },
    ...mapMutations(['setClubMembers']),
    upgradeToAdmin() {
      Repository.changeClubMemberRol(this.member.id, 'ADMIN').then((response) => {
        if(response.status < 400) {
          alert(`${this.member.user.firstName} was upgraded successfully.`);
          Repository.getAllClubMembers(this.member.club.id).then((secondResponse) => {
            if (secondResponse.status < 400) {
              this.setClubMembers(secondResponse.data);
              this.close();
            }
          });
        }
      });
    },
    ...mapMutations(['setClubMembers']),
    downgradeToMember() {
      Repository.changeClubMemberRol(this.member.id, 'MEMBER').then((response) => {
        if(response.status < 400) {
          alert(`${this.member.user.firstName} was downgraded successfully.`);
          Repository.getAllClubMembers(this.member.club.id).then((secondResponse) => {
            if (secondResponse.status < 400) {
              this.setClubMembers(secondResponse.data);
              this.close();
            }
          });
        }
      });
    },
    ...mapMutations(['setClubMembers']),
    removeMember() {
      Repository.denyClubMember(this.member.id).then((response) => {
        if(response.status < 400) {
          alert(`${this.member.user.firstName} was removed successfully.`);
          Repository.getAllClubMembers(this.member.club.id).then((secondResponse) => {
            if (secondResponse.status < 400) {
              this.setClubMembers(secondResponse.data);
              this.close();
            }
          });
        }
      }).catch(() => {
        alert(`${this.member.user.firstName} is an active member of club channels/posts/events.\nFirst delete all contributions of ${this.member.user.firstName} to remove member.`);
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped>
  .remove-button {
    background-color: #FF4747 !important;
    color: #FFFFFF !important;
    border: #FF4747 solid 2px !important;
  }

  .remove-button:hover {
    background-color: #FF4747 !important;
    color: #FFFFFF !important;
    border: #FF4747 solid 2px !important;
  }
</style>
